<div
  class="pm-route-data d-flex flex-column h-100 w-100"
  [class.pm-route-data--embedded]="embedded"
>
  <div *ngIf="isLoading" class="pm-route-data__loader">
    <app-loader></app-loader>
  </div>

  <div
    *ngIf="!isLoading && !hasEntries"
    class="pm-route-data__empty text-muted text-center py-4"
  >
    {{ "headers.routing.plan.pm_route.no_reports" | translate }}
  </div>

  <div
    *ngIf="!isLoading && hasEntries && isFlatView"
    class="pm-route-data__feedback-list flex-grow-1"
  >
    <div
      *ngFor="let entry of flatEntries"
      class="card pm-route-data__entry mb-2"
    >
      <div class="card-body py-2">
        <div class="d-flex align-items-center flex-wrap mb-2">
          <span
            class="badge badge-lg mr-2"
            [ngClass]="badgeClass(entry.type)"
          >
            {{ ("headers.routing.plan.pm_route." + entry.type) | translate }}
          </span>
          <span class="text-muted pm-route-data__report-meta-line">
            {{ formatCreatedAt(entry.created_at) }}<span class="pm-route-data__report-sep">|</span>{{ entry.user_name }}
          </span>
        </div>
        <div class="d-flex flex-wrap pm-route-data__entry-body">
          <div class="pm-route-data__entry-fields flex-grow-1">
            <ng-container
              *ngTemplateOutlet="entryFields; context: { entry: entry, type: entry.type, flat: true }"
            ></ng-container>
          </div>
          <div
            *ngIf="entry.type === 'issue' && entry.has_images"
            class="pm-route-data__entry-images"
          >
            <app-core-image-slider
              [entityType]="'pm_route_issue'"
              [entityId]="entry.id"
              [editable]="false"
            ></app-core-image-slider>
          </div>
          <div
            *ngIf="entry.type === 'measurement' && entry.has_images"
            class="pm-route-data__entry-images"
          >
            <app-core-image-slider
              [entityType]="'pm_route_measurement'"
              [entityId]="entry.id"
              [editable]="false"
            ></app-core-image-slider>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isLoading && hasEntries && !isFlatView"
    class="pm-route-data__reports flex-grow-1"
  >
    <div
      *ngFor="let report of reports; let i = index"
      class="card pm-route-data__report mb-2"
    >
      <div
        class="card-header pm-route-data__report-heading py-2"
        (click)="toggleReport(i)"
      >
        <div
          class="d-flex justify-content-between align-items-center w-100"
        >
          <div class="pm-route-data__report-title">
            <span class="font-weight-bold">
              {{ "headers.routing.plan.pm_route.report" | translate }}
              #{{ reportNumber(i) }}
            </span>
            <span class="text-muted ml-2 pm-route-data__report-meta-line">
              {{ formatCreatedAt(report.created_at) }}<span class="pm-route-data__report-sep">|</span>{{ report.user_name }}
            </span>
          </div>
          <div class="pm-route-data__report-meta d-flex align-items-center">
            <span
              *ngIf="report.issues.length"
              class="badge badge-warning badge-lg mr-1"
            >
              {{ report.issues.length }}
              {{ "headers.routing.plan.pm_route.issue" | translate }}
            </span>
            <span
              *ngIf="report.measurements.length"
              class="badge badge-primary badge-lg mr-1"
            >
              {{ report.measurements.length }}
              {{ "headers.routing.plan.pm_route.measurement" | translate }}
            </span>
            <span
              *ngIf="report.skipped_assets.length"
              class="badge badge-secondary badge-lg mr-2"
            >
              {{ report.skipped_assets.length }}
              {{ "headers.routing.plan.pm_route.skipped_asset" | translate }}
            </span>
            <i
              class="la la-caret-down la-lg text-muted pm-route-data__caret"
              [class.pm-route-data__caret--closed]="!report.isOpen"
            ></i>
          </div>
        </div>
      </div>

      <div *ngIf="report.isOpen" class="card-body py-2 pm-route-data__entries">
          <div
            *ngFor="let issue of report.issues"
            class="card pm-route-data__entry mb-2"
          >
            <div class="card-body py-2">
              <span class="badge badge-warning badge-lg mb-2">
                {{ "headers.routing.plan.pm_route.issue" | translate }}
              </span>
              <div class="d-flex flex-wrap pm-route-data__entry-body">
                <div class="pm-route-data__entry-fields flex-grow-1">
                  <ng-container
                    *ngTemplateOutlet="entryFields; context: { entry: issue, type: 'issue', flat: false }"
                  ></ng-container>
                </div>
                <div *ngIf="issue.has_images" class="pm-route-data__entry-images">
                  <app-core-image-slider
                    [entityType]="'pm_route_issue'"
                    [entityId]="issue.id"
                    [editable]="false"
                  ></app-core-image-slider>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngFor="let measurement of report.measurements"
            class="card pm-route-data__entry mb-2"
          >
            <div class="card-body py-2">
              <span class="badge badge-primary badge-lg mb-2">
                {{ "headers.routing.plan.pm_route.measurement" | translate }}
              </span>
              <div class="d-flex flex-wrap pm-route-data__entry-body">
                <div class="pm-route-data__entry-fields flex-grow-1">
                  <ng-container
                    *ngTemplateOutlet="entryFields; context: { entry: measurement, type: 'measurement', flat: false }"
                  ></ng-container>
                </div>
                <div
                  *ngIf="measurement.has_images"
                  class="pm-route-data__entry-images"
                >
                  <app-core-image-slider
                    [entityType]="'pm_route_measurement'"
                    [entityId]="measurement.id"
                    [editable]="false"
                  ></app-core-image-slider>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngFor="let skipped of report.skipped_assets"
            class="card pm-route-data__entry mb-2"
          >
            <div class="card-body py-2">
              <span class="badge badge-secondary badge-lg mb-2">
                {{ "headers.routing.plan.pm_route.skipped_asset" | translate }}
              </span>
              <div class="d-flex flex-wrap pm-route-data__entry-body">
                <div class="pm-route-data__entry-fields flex-grow-1">
                  <ng-container
                    *ngTemplateOutlet="entryFields; context: { entry: skipped, type: 'skipped_asset', flat: false }"
                  ></ng-container>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="entryCount(report) === 0"
            class="text-muted text-center py-2"
          >
            {{ "headers.routing.plan.pm_route.no_entries" | translate }}
          </div>
      </div>
    </div>
  </div>
</div>

<ng-template #entryFields let-entry="entry" let-type="type" let-flat="flat">
  <div *ngIf="!flat" class="pm-route-data__field">
    <span class="font-size-smaller text-muted">
      {{ "headers.location.location" | translate }}:
    </span>
    <span class="font-weight-bold">{{ entry.location_name || "—" }}</span>
  </div>
  <div *ngIf="!flat" class="pm-route-data__field">
    <span class="font-size-smaller text-muted">
      {{ "headers.routing.plan.pm_route.asset_full_name" | translate }}:
    </span>
    <span class="font-weight-bold">{{ entry.asset_full_name }}</span>
  </div>
  <div *ngIf="flat" class="pm-route-data__field">
    <span class="font-size-smaller text-muted">
      {{ "headers.routing.plan.pm_route.route" | translate }}:
    </span>
    <span class="font-weight-bold">{{ entry.plan_name }}</span>
  </div>
  <div
    *ngIf="type !== 'skipped_asset' || entry.task_component"
    class="pm-route-data__field"
  >
    <span class="font-size-smaller text-muted">
      {{ "headers.tasks_parameters.component.component" | translate }}:
    </span>
    <span class="font-weight-bold">{{ entry.task_component }}</span>
  </div>
  <div
    *ngIf="type !== 'skipped_asset' || entry.task_description"
    class="pm-route-data__field"
  >
    <span class="font-size-smaller text-muted">
      {{ "headers.fastpm.pm_model.description" | translate }}:
    </span>
    <span class="font-weight-bold">{{ entry.task_description }}</span>
  </div>
  <div *ngIf="type === 'issue'" class="pm-route-data__field">
    <span class="font-size-smaller text-muted">
      {{ "headers.routing.plan.pm_route.issue_comments" | translate }}:
    </span>
    <span class="font-weight-bold">{{ entry.issue_comments }}</span>
  </div>
  <div *ngIf="type === 'measurement'" class="pm-route-data__field">
    <span class="font-size-smaller text-muted">
      {{ "headers.routing.plan.pm_route.measured_value" | translate }}:
    </span>
    <span class="font-weight-bold">{{
      entry.measure_type === "value"
        ? entry.value_numeric
        : entry.measure_type
          ? entry.value_text
          : entry.measured_value
    }}</span>
  </div>
  <ng-container *ngIf="type === 'skipped_asset'">
    <div class="pm-route-data__field">
      <span class="font-size-smaller text-muted">
        {{ "headers.routing.plan.pm_route.skip_reason" | translate }}:
      </span>
      <span class="font-weight-bold">{{ entry.skip_reason }}</span>
    </div>
    <div *ngIf="entry.skip_comments" class="pm-route-data__field">
      <span class="font-size-smaller text-muted">
        {{ "headers.routing.plan.pm_route.skip_comments" | translate }}:
      </span>
      <span class="font-weight-bold">{{ entry.skip_comments }}</span>
    </div>
  </ng-container>
</ng-template>
